//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SearchServiceQuery: any = {
    getStockDetail: Backofficebff + '/v1/productstocks/stockdetail',
    getProductDetail: Backofficebff + '/v1/productstocks/productdetail',
    getProductDetailAll: Backofficebff + '/v1/productstocks/productdetailAll',
    getTeknikFoy: Backofficebff + '/v1/retaildb/get-style-images-by-special-code',
    getAllWarehouses: Backofficebff + '/v1/productstocks/get-all-warehouses',
    getAllWarehousesGroups: Backofficebff + '/v1/productstocks/get-all-warehouse-groups',
    getAllWarehousesById: Backofficebff + '/v1/productstocks/get-warehouse-summary-by-warehouse-id',
    getAllWarehousesByGroupId: Backofficebff + '/v1/productstocks/get-warehouse-summaries-by-warehouse-group-id',
    GetCentralStockInfo: Backofficebff + '/v1/productstocks/get-central-stock-info',
};
